import AppShellHeader from './components/Header/Header';
import UserMenu from './components/UserMenu/UserMenu';
import useConnectedAppShellHeader from './useConnectedAppShellHeader';

function ConnectedAppShellHeader() {
  const {
    cashBalance,
    balance,
    credits,
    refundableBalance,
    playthroughCash,
    handleOpenDepositModal,
    handleOpenWithdrawalModal,
    isBalanceLoading,
    isProtectionLoading,
    isUserMenuOpen,
    KYCStatus,
    notificationsCount,
    promotionsCount,
    toggleUserMenu,
    user,
    userWidgetProps,
  } = useConnectedAppShellHeader();

  return (
    <>
      <AppShellHeader
        user={userWidgetProps}
        handleDepositClick={handleOpenDepositModal}
        handleUserClick={toggleUserMenu}
      />
      {isUserMenuOpen && (
        <UserMenu
          user={user}
          onClose={toggleUserMenu}
          KYCStatus={KYCStatus}
          notificationsCount={notificationsCount}
          promotionsCount={promotionsCount}
          cashBalance={cashBalance}
          balance={balance}
          credits={credits}
          refundableBalance={refundableBalance}
          playthroughCash={playthroughCash}
          handleOpenWithdrawalModal={handleOpenWithdrawalModal}
          handleOpenDepositModal={handleOpenDepositModal}
          isLoading={isBalanceLoading}
          isProtectionLoading={isProtectionLoading}
        />
      )}
    </>
  );
}

export default ConnectedAppShellHeader;
